import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteChequeById, getChequeList } from '../../Redux/Actions/DashOptions'
import Loader from '../../Common/Loader'
import { faCheckCircle, faEdit, faSearch, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import AlertDialogSlide from '../../Common/DeleteDialog'
import { toast } from 'react-toastify'
import { capitalizeFirstLetter, formatDateToDDMMYYYY } from '../../Utils/helper'
import Pagination from '../../Common/Pagination'
import { Box, Button, Modal, Typography } from '@mui/material'

const ChequeList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const [deleteId, setDeleteID] = useState()
    const [expanded, setExpanded] = useState(false);
    const [openProcessAI, setProcessAi] = useState(false)
    const [loading, setLoading] = useState(false)


    const chequeData = useSelector((state) => state?.DashOptionsSlice?.getChequeList?.data?.data) // cheque list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading
    const { current_page, last_page, from, to, total } = useSelector((state) => state?.DashOptionsSlice?.getChequeList?.data || {}); // getting pagination

    const [page, setPage] = useState(current_page || 1);

    const handleEdit = (seletedItem) => {
        navigate(`/dashboard/addcheque/${seletedItem?.id}`, { state: { editChequeData: seletedItem } })
    }

    const handleDelete = (selectedID) => {
        setDeleteID(selectedID)
        setOpen(true)
    }

    const handleDeleteByModal = () => {
        dispatch(deleteChequeById(deleteId)).then((res) => {
            if (res?.payload) {
                toast.success(res?.payload?.message)
                setOpen(false);
                dispatch(getChequeList({ page: page }))
            } else {
                toast.error('An error occured')
            }
        })
    }

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleMangeCheque = (selectedID) => {
        if (selectedID?.status === 0) {
            setProcessAi(true)
        } else {
            navigate(`/dashboard/viewchequedetails/${selectedID?.id}?details=cheqdetails`, { state: { editChequeData: selectedID } })
        }
    }
    const handleManualDetails = (selectedID) => {
        navigate(`/dashboard/recheckDetail/${selectedID?.id}`)
        setLoading(true)
    }



    const handleClose = () => {
        setProcessAi(false)
    }

    useEffect(() => {
        dispatch(getChequeList({ page: page }))
    }, [])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        borderRadius: '12px',
        boxShadow: 24,
        p: 4,
    };
    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            {(clientListLoading || loading) && <Loader />}
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Cheque Details</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-blue-600 text-white">
                        <tr>
                            <th className="py-2 px-2 text-sm text-left">Cheque Number</th>
                            <th className="py-2 px-2 text-sm text-left">Date</th>
                            <th className="py-2 px-2 text-sm text-left">Amount</th>
                            <th className="py-2 px-2 text-sm text-left">Payer Name</th>
                            <th className="py-2 px-3 text-sm text-left">Client</th>
                            <th className="py-2 px-2 text-sm text-left">Provider</th>
                            <th className="py-2 px-4 text-sm text-left">Cheque Type</th>
                            <th className="py-2 px-2 text-sm text-left">Notes</th>
                            <th className="py-2 px-2  text-sm text-left">Status</th>
                            <th className="py-2 px-2 text-sm text-left">Manage</th>
                            <th className="py-2 px-2 text-sm text-left"></th>
                            <th className="py-2 px-2 text-sm text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>

                        {chequeData && chequeData?.length > 0 ? (
                            chequeData.map((cheque, index) => (
                                <tr
                                    key={index}
                                    className="border-b hover:bg-gray-100 transition duration-200"
                                >
                                    <td className="py-3 text-sm px-2">{capitalizeFirstLetter(cheque?.cheque_number) || '--'}</td>
                                    <td className="py-3 text-sm px-2">{formatDateToDDMMYYYY(cheque?.cheque_date) || '--'}</td>
                                    <td className="py-3 text-sm px-2">${cheque?.amount || '--'}</td>
                                    <td className="py-3 text-sm px-2">{cheque?.payer_name || '--'}</td>
                                    <td className="py-3 text-sm px-2">{cheque?.client?.name || '--'}</td>
                                    <td className="py-3 text-sm px-2">{cheque?.provider?.name || '--'}</td>
                                    <td className="py-3 text-sm px-2">{cheque?.cheque_type?.name || '--'}</td>
                                    <td className="py-3 text-sm px-2">
                                        {(() => {
                                            const limit = 50;
                                            const note = cheque?.notes;

                                            if (!note) return '--';

                                            const isLong = note.length > limit;
                                            const displayText = expanded || !isLong ? note : `${note.slice(0, limit)}...`;

                                            return (
                                                <>
                                                    <span>{displayText}</span>
                                                    {isLong && (
                                                        <button
                                                            className="ml-1 text-blue-500 text-sm hover:underline focus:outline-none"
                                                            onClick={() => setExpanded(prev => !prev)}
                                                        >
                                                            {expanded ? 'Read less' : 'Read more'}
                                                        </button>
                                                    )}
                                                </>
                                            );
                                        })()}
                                    </td>
                                    <td className="py-3 px-2">
                                        {cheque?.status === 0 ? (
                                            <span className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full shadow-sm text-sm font-medium">
                                                <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                                                <span>Processing</span>
                                            </span>
                                        ) : cheque?.status === 1 ? (
                                            <span className=" whitespace-nowrap inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-2 py-1 rounded-full shadow-sm text-sm font-medium">
                                                <FontAwesomeIcon icon={faSearch} className="text-blue-700" />
                                                <span>Review & Process</span>
                                            </span>
                                        ) : cheque?.status === 2 ? (
                                            <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-2 py-1 rounded-full shadow-sm text-sm font-medium">
                                                <FontAwesomeIcon icon={faCheckCircle} className="text-green-500" />
                                                <span>Completed</span>
                                            </span>
                                        ) : null}
                                    </td>
                                    <td className="py-3 px-2">
                                        <button
                                            onClick={() => handleMangeCheque(cheque)}
                                            disabled={cheque?.status === 2}
                                            className={`whitespace-nowrap font-semibold py-2 px-2 rounded-full shadow-md 
    transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 text-xs
    ${cheque?.status === 2
                                                    ? 'bg-gray-400 text-white cursor-not-allowed'
                                                    : 'bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white focus:ring-blue-400'}
  `}
                                        >
                                            Manage
                                        </button>

                                    </td>
                                    {cheque?.status === 2 ? (
                                        <td className="py-3 px-2">
                                            <button
                                                onClick={() => handleManualDetails(cheque)}
                                                className="whitespace-nowrap bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 
               text-white font-semibold py-2 px-2 rounded-full shadow-md 
               hover:shadow-lg transition-all duration-200 ease-in-out 
               focus:outline-none focus:ring-2 focus:ring-pink-400 text-xs"
                                            >
                                                Manual Details
                                            </button>
                                        </td>

                                    ) : (
                                        <td className="py-3 px-2"></td>
                                    )}
                                    <td className="px-2 py-4 whitespace-nowrap text-center text-sm font-medium flex items-center justify-center gap-2 ">
                                        <button className="text-blue-600 hover:text-blue-900" onClick={() => handleEdit(cheque)}><FontAwesomeIcon icon={faEdit} className="text-blue-600" /></button>
                                        <button className="text-red-600 hover:text-blue-900" onClick={() => handleDelete(cheque?.id)}><FontAwesomeIcon icon={faTrash} className="text-red-600" /></button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" className="py-6 text-center text-gray-900">
                                    No Cheque data available.
                                </td>
                            </tr>
                        )
                        }

                        <tr></tr>

                    </tbody>
                </table>
                <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                    <p className="text-sm text-gray-700">
                        Showing <span className="font-medium">{from}</span> to <span className="font-medium">{to}</span> of <span className="font-medium">{total}</span> results
                    </p>
                    <Pagination
                        count={last_page}
                        page={page}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
            <AlertDialogSlide open={open} setOpen={setOpen} handleDeleteByModal={handleDeleteByModal} />
            <Modal
                open={openProcessAI}
                onClose={handleClose}
                aria-labelledby="add-provider-title"
                aria-describedby="add-provider-description"
            >
                <Box sx={style}>
                    <div className="flex flex-col items-center justify-center space-y-4">
                        <FontAwesomeIcon icon={faSpinner} spin className="text-4xl text-indigo-600" />
                        <Typography
                            id="ai-processing-title"
                            variant="h6"
                            component="h2"
                            className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500"
                        >
                            Processing Cheque with AI
                        </Typography>
                        <Typography id="ai-processing-description" className="text-sm text-gray-600  flex text-center">
                            Please wait while we read and extract the data from the cheque. This may take a few moments.
                        </Typography>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={handleClose}
                            className="mt-4"
                            sx={{
                                mt: 3,
                                px: 4,
                                py: 1.5,
                                fontWeight: 'bold',
                                color: '#fff',
                                background: 'linear-gradient(to right, #ff4b2b, #ff416c)',
                                borderRadius: '30px',
                                boxShadow: '0 4px 14px rgba(255, 65, 108, 0.4)',
                                textTransform: 'none',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: 'linear-gradient(to right, #ff416c, #ff4b2b)',
                                    boxShadow: '0 6px 20px rgba(255, 65, 108, 0.6)',
                                    transform: 'scale(1.05)',
                                }
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    )
}

export default ChequeList
